// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"d0e97fc4","180":"be70e7ae","404":"3e4c49ee","593":"1c04f7f3"}[chunkId] + ".chunk.js";
};